export default __webpack_public_path__ + "static/media/2013-FR.1e7dccec.jpg";